import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext();
export const AbilityProvider = AbilityContext.Provider

export const Can = createContextualCan(AbilityContext.Consumer);